import { render, staticRenderFns } from "./LineageComponent.vue?vue&type=template&id=1899cee6&lang=pug"
import script from "./LineageComponent.vue?vue&type=script&lang=js"
export * from "./LineageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1899cee6')) {
      api.createRecord('1899cee6', component.options)
    } else {
      api.reload('1899cee6', component.options)
    }
    module.hot.accept("./LineageComponent.vue?vue&type=template&id=1899cee6&lang=pug", function () {
      api.rerender('1899cee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lineage/LineageComponent.vue"
export default component.exports